import React from 'react';
import Button from '../../ui/button/button';
import Icon from '../../ui/icon/icon';

export default function BackButton({ title = '', isSubmitting = false, isGoingBack = false, onSubmit = () => {} }) {

    const _onSubmit = React.useCallback(() => {
        onSubmit({
            data: {
                action: 'previous'
            }
        }, true);
    },[onSubmit]);

    return (
        <div className='neo-back-button'>
            <Button 
                type='secondary' 
                label={
                    <>
                        <Icon name='arrowLeft'/>
                        <span>{title}</span>
                    </>
                } 
                isLoading={isGoingBack}
                disabled={isSubmitting}
                onClick={_onSubmit}
            />
        </div>
    )
}
